<template>
	<b-form data-vv-scope="bank_account" @submit.prevent="nextStep">
		<div class="d-flex flex-column" style="gap: 24px;">
			<div class="title">
				<h5>{{ $t("views.seller.my_account.text_1265") }}</h5>
				<p>{{ $t("views.seller.my_account.text_1296") }}</p>
			</div>
			
			<b-row>
				<b-col cols="6" md="6">
          <div class="bank-select-container">
            <label class="typo__label">{{ $t('views.seller.my_account.bank_account.text_1311') }}</label>
            <multiselect 
              id="bank-select" 
              name="bank"
              v-model="selectedOption" 
              v-validate="'required'"
              :options="banks" 
              :placeholder="$t('views.seller.my_account.bank_account.text_1311')" 
              :allow-empty="false"
              label="name"          
              track-by="name"
              deselect-label=""
              selectLabel=""
              selectedLabel=""
              :disabled="$root.modeEdit"
            />
            <p v-if="errors.has('bank_account.bank')" class="mt-2" style="font-size: 0.875em; color: #ff0c37">
              {{ $t('seller.my_account.bank_account.error_bank') }}
            </p>
          </div>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="6" md="3">
					<BaseInput 
						name="agency"
            v-model="agency"
						v-mask="'#########'"
						v-validate="'required'"
						autocomplete="off"
						type="text"
            :isValid="!errors.has('bank_account.agency')"
            :errorMessage="$t('seller.my_account.bank_account.error_agency')"
						:label="$t('views.seller.my_account.bank_account.text_1297')" 
						:placeholder="$t('views.seller.my_account.bank_account.text_1298')"
            :disabled="$root.modeEdit"
					/>
				</b-col>
				<b-col cols="6" md="3">
					<BaseInput 
						name="agency_dv"
            v-model="agency_dv"
						v-mask="'#'"
						autocomplete="off"
						type="text"
						:label="$t('views.seller.my_account.bank_account.text_1299')" 
						:placeholder="$t('views.seller.my_account.bank_account.text_1300')"
            :disabled="$root.modeEdit"
					/>
				</b-col>
			</b-row>

			<b-row>
				<b-col cols="6" md="3">
					<div class="position-relative">
						<BaseInput
							name="account"
              v-model="account"
							v-validate="'required'"
							v-mask="'############'"
							autocomplete="off"
							:isValid="!errors.has('bank_account.account')"
            	:errorMessage="$t('seller.my_account.bank_account.error_account')"
							:label="$t('views.seller.my_account.bank_account.text_1301')" 
							:placeholder="$t('views.seller.my_account.bank_account.text_1302')"
              :disabled="$root.modeEdit"
						/>
						<img
							src="@/assets/img/icons/question-mark-circle.svg"
							class="position-absolute"
							style="right: 11px; bottom: 9px"
							id="tooltip-account"
						>
						<b-tooltip target="tooltip-account" triggers="hover">
							<span class="d-block text-white" style="font-size: 12px;">{{ $t('views.seller.my_account.bank_account.text_1313') }}</span>
							<span class="d-block text-white" style="font-size: 12px;">{{ $t('views.seller.my_account.bank_account.text_1314') }}</span>
						</b-tooltip>
					</div>
				</b-col>
				<b-col cols="6" md="3">
					<BaseInput
						name="account_dv"
            v-model="account_dv"
						type="text"
            v-validate="'required'"
						autocomplete="off"
            :isValid="!errors.has('bank_account.account_dv')"
            :errorMessage="$t('seller.my_account.bank_account.error_account_dv')"
						:label="$t('views.seller.my_account.bank_account.text_1303')" 
						:placeholder="$t('views.seller.my_account.bank_account.text_1304')"
            :disabled="$root.modeEdit"
					/>
				</b-col>
			</b-row>

      <b-row>
        <b-col cols="12" md="12">
          <BaseInputFile 
						:label="$t('views.seller.my_account.bank_account.text_1305')"
            :extensions="['pdf', 'jpg', 'png']"
            :maxSize="10"
            :instructionsLabel="$t('views.seller.my_account.bank_account.text_1306')"
            :instructions="[
              { icon: 'mobile.png', label: this.$t('views.seller.my_account.bank_account.text_1307')},
              { icon: 'receipt.png', label: this.$t('views.seller.my_account.bank_account.text_1308')},
              { icon: 'card.png', label: this.$t('views.seller.my_account.bank_account.text_1309')},
              { icon: 'document-text.png', label: this.$t('views.seller.my_account.bank_account.text_1310')},
            ]"
            sizeUnit="mb"
            v-model="file"
            :errorMessage="fileError"
          />
        </b-col>
      </b-row>
		</div>
	</b-form>
</template>

<script>
import Multiselect from 'vue-multiselect';
import BankService from '@/services/resources/BankService';
import BankAccountService from '@/services/resources/BankAccountService';

const bankService = BankService.build();
const bankAccountService = BankAccountService.build();

export default {
  components: {
    Multiselect
  },
	name: 'BankAccountFormStep',	props: {
		user: {
			type: Object,
		}
	},
	data() {
		return {
			banks: [],
			selectedOption: null,
      file: null,
      fileError: '',
      id: null,
      bank_number: null,
      bank_name: null,
      agency: null,
      agency_dv: null,
      account: null,
      account_dv: null,
      modality: null,
		}
	},
  watch: {
    file() {
      if (this.file) {
        this.fileError = '';
      }
    }
  },
	methods: {
		async fetchBanks() {
			try {
				const banksList = await bankService.search();

				this.banks = banksList.map(({ name, code }) => ({ id: code, name }));
			} catch (error) {
        console.error('BankAccountFormStep::fetchBanks', error);
			}
    },
    async validateForm() {
      try {
        const fileValidated = this.validateFile();
        const formValidated = await this.$validator.validateAll('bank_account');
        
        return (fileValidated && formValidated);
      } catch(error) {
        console.error('BankAccountFormStep::validateForm', error);
        return false;
      }
    },

    async uploadFile(bankAccountId) {
      try {
        const form = new FormData();

        form.append('document', this.file);
        form.append('subtype', 'PROOF_ACCOUNT_BANK');

        await bankAccountService.create(form, `/${bankAccountId}/upload`);

      } catch(error) {
        console.error('BankAccountFormStep::uploadFile', error);
      }
    },

    async handleSubmit() {
      try {
        const data = {
          bank_number: this.selectedOption.id,
          bank_name: this.selectedOption.name.trim(),
          agency: this.agency,
          agency_dv: this.agency_dv || null,
          account_dv: this.account_dv,
          account: this.account,
          type: 'CURRENT',
          account_type: this.$root.accountType ?? 'PERSONAL',
          name: this.name,
          user_id: this.user.id,
          international_account_type: null,
          bic_swift: null,
          currencies: [1],
          country: "BR",
        };

				this.$root.$emit('on-saving', true);

        if (this.id) {
          await bankAccountService.update(data, this.id);
        } else {
          const { id } = await bankAccountService.create(data);
  
          this.id = id;
        }

        if (this.file.size) {
          await this.uploadFile(this.id);
        }

        this.$bvToast.toast(
          this.$t('seller.statements.modals.bank_account.text_816'),
          {
            title: this.$t('seller.statements.modals.bank_account.text_2722'),
            variant: 'success',
            autoHideDelay: 5000,
            appendToast: true,
          }
        );
      } catch (err) {
        console.log('BankAccountFormStep - handleSubmit: ', err);
      } finally {
				this.$root.$emit('on-saving', false);
			}
    },
    validateFile() {
      if (!this.file) {
        this.fileError = this.$t('views.seller.my_account.text_1338')
        return false;
      }
      return this.file;
    },
    fillData(bankAccount) {
      if (!bankAccount.id) {
        return
      }
      this.selectedOption = {
        id: bankAccount.bank_number,
        name: bankAccount.bank_name
      };

      this.id = bankAccount.id;
      this.bank_number = bankAccount.bank_number;
      this.bank_name = bankAccount.bank_name;
      this.agency = bankAccount.agency;
      this.agency_dv = bankAccount.agency_dv;
      this.account = bankAccount.account;
      this.account_dv = bankAccount.account_dv;

      if (bankAccount.last_document) {
        const ext = bankAccount.last_document.path.split('.').pop().toLowerCase();
        const blob = new Blob();
        this.file = new File([blob], `comprovante-conta-bancaria.${ext}`); 
      }
    }
	},
	async mounted() {
	  await this.fetchBanks();
    if (
      this.$root.myAccountData 
      && this.$root.myAccountData.bankAccount
      && this.$root.myAccountData.bankAccount.status !== null
    ) {
      this.fillData(this.$root.myAccountData.bankAccount);
    }
	}
};
</script>

<style>
.bank-select-container .multiselect__tags {
  padding: 0px !important;
  display: flex;
  align-content: center;
  align-items: center;
  padding: 0px 12px !important;
}
.bank-select-container .multiselect__single {
  margin: 0 !important;
}

.bank-select-container .multiselect__select {
  top: 2px !important;
}

.bank-select-container .multiselect__input{
  margin: 0 !important;
  transition: none !important;
}

.bank-select-container .multiselect__option--highlight {
  background-color: var(--Default-color-primary-800) !important;
}

.bank-select-container .multiselect__option--highlight span{
  color: #fff !important;
  background-color: var(--Default-color-primary-800) !important;
}

.bank-select-container .multiselect__content {
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}
.bank-select-container .multiselect__placeholder {
  padding: 0 !important;
}
</style>
